import type { ColumnDef } from '@tanstack/react-table';
import { DataTableColumnHeader } from '@/components/ui/data-table';
import { Badge } from '@/components/ui/badge';
import type { ToolExecutionLog } from '@/services';
import { ConversationTicketLink } from './conversation-ticket-link';

const renderJsonPreview = (value: unknown) => <span className='block truncate'>{value == null ? '—' : JSON.stringify(value)}</span>;

export function getToolExecutionLogsColumns(): ColumnDef<ToolExecutionLog>[] {
	return [
		{
			accessorKey: 'requestId',
			header: ({ column }) => <DataTableColumnHeader column={column} title='Request ID' />,
			cell: ({ row }) => (
				<span className='block truncate font-medium text-foreground' title={row.original.requestId || undefined}>
					{row.original.requestId || '—'}
				</span>
			),
			size: 140
		},
		{
			accessorKey: 'conversationId',
			header: 'Conversation',
			cell: ({ row }) => <ConversationTicketLink log={row.original} />,
			enableSorting: false,
			size: 110
		},
		{
			accessorKey: 'input',
			header: 'Input',
			cell: ({ row }) => renderJsonPreview(row.original.input),
			enableSorting: false,
			size: 180
		},
		{
			accessorKey: 'output',
			header: 'Output',
			cell: ({ row }) => renderJsonPreview(row.original.output),
			enableSorting: false,
			size: 180
		},
		{
			accessorKey: 'latencyMs',
			header: 'Latency',
			cell: ({ row }) => `${row.original.latencyMs} ms`,
			enableSorting: false,
			size: 80
		},
		{
			accessorKey: 'statusCode',
			header: 'Status code',
			// Provider errors still return 200, so the colour comes from status, not the code.
			cell: ({ row }) => (
				<Badge
					variant={row.original.status === 'success' ? 'success' : 'destructive'}
					title={row.original.errorCode ?? undefined}
				>
					{row.original.statusCode}
				</Badge>
			),
			enableSorting: false,
			size: 120
		}
	];
}
